import { Button, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const AlertContainer = styled.div<{
  $isError?: boolean;
  $insideModal?: boolean;
}>`
  position: absolute;
  top: ${({ $insideModal }) => ($insideModal ? '50px' : '-74px')};
  z-index: calc(var(--z-index-modal) + 1);
  width: ${({ $insideModal }) =>
    $insideModal ? 'calc(100% - 40px)' : '640px'};
  padding: 16px;
  border-radius: 8px;
  border: ${({ $isError }) =>
    $isError
      ? '1px solid var(--border-critical)'
      : '1px solid var(--border-default)'};
  background: ${({ $isError }) =>
    $isError ? 'var(--surface-critical)' : 'var(--surface-default)'};
  box-shadow: var(--elevation-strong);
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AlertDescription = styled.div`
  width: 100%;
  ${typographyV2.titleSm};
  color: var(--text-default);
`;

export const Close = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  padding: 5px;
  height: 24px;
  width: 24px;

  svg {
    fill: var(--icon-soft);
  }

  &:hover svg {
    fill: var(--icon-default);
  }
`;

export const StyledViewUnMapped = styled(Button)`
  margin-left: 30px;
  margin-top: 12px;
  border-radius: 8px;
  border: 1px solid var(--border-primary);
`;
